var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCatalogue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C29E51;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.7,43.9v-6.2h24.8v6.2H32.7z M32.7,31.5v-6.2h24.8v6.2H32.7z M26.4,50.2h23.2c1.5,0,2.9,0.4,4.2,1 s2.4,1.6,3.2,2.7l6.5,8.5V19.1H26.4V50.2z M26.4,68.8h34.3l-8.4-11.1c-0.4-0.4-0.7-0.7-1.1-1s-0.9-0.4-1.4-0.4H26.4V68.8z M63.6,75 H26.4c-1.7,0-3.2-0.6-4.4-1.8s-1.8-2.7-1.8-4.4V19.1c0-1.7,0.6-3.2,1.8-4.4s2.7-1.8,4.4-1.8h37.2c1.7,0,3.2,0.6,4.4,1.8 s1.8,2.7,1.8,4.4v49.6c0,1.7-0.6,3.2-1.8,4.4C66.8,74.4,65.4,75,63.6,75z M26.4,68.8V19.1V68.8z M26.4,56.3v-6.2V56.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCatalogue);
export default __webpack_public_path__ + "static/media/product-catalogue.a6efc619df89b07af137bb2b618537d6.svg";
export { ForwardRef as ReactComponent };